import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { listproducts } from "../data/listproducts";
import { Link } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import '../styles/productinfo.css';

const Info = () => {
    const { name } = useParams();
    const [activeSection, setActiveSection] = useState(null);
    const [inProp, setInProp] = useState(false);

    // Procurando o produto por nome
    const allProducts = Object.values(listproducts).flat();
    const product = allProducts.find(item => item.name.toLowerCase().trim() === name.toLowerCase().trim());

    useEffect(() => {
        setInProp(true);
    }, []);

    if (!product) {
        return <h2>Produto não encontrado</h2>;
    }

    const toggleSection = (section) => {
        setActiveSection(activeSection === section ? null : section);
    };

    // Filtrar produtos relacionados pelo tipo
    const relatedProducts = allProducts.filter(item => item.type === product.type && item.name !== product.name);

    return (
        <div className="maindiv">
            <h1 id="type">{product.type}</h1>
            <div className="row-part">
                <img src={product.image} alt={product.name} />
                <div className="column-information">
                    <h1>{product.name}</h1>

                    {/* Exibe a lista de child, se houver */}
                    {product.child && product.child.length > 0 && (
                        <ul className="child-list">
                            {product.child.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    )}

                    <p>{product.shortdescription}</p>
                </div>
            </div>

            <div className="lowerpart">
                {product.longdescription && (
                    <div className="accordion">
                        <button
                            className={`accordion-button ${activeSection === 'longdescription' ? 'active' : ''}`}
                            onClick={() => toggleSection('longdescription')}
                        >
                            Descrição
                        </button>
                        <div className={`accordion-content ${activeSection === 'longdescription' ? 'open' : ''}`}>
                            <p>{product.longdescription}</p>
                        </div>
                    </div>
                )}

                {product.applicationDescription && (
                    <div className="accordion">
                        <button
                            className={`accordion-button ${activeSection === 'applicationDescription' ? 'active' : ''}`}
                            onClick={() => toggleSection('applicationDescription')}
                        >
                            Aplicações
                        </button>
                        <div className={`accordion-content ${activeSection === 'applicationDescription' ? 'open' : ''}`}>
                            <p>{product.applicationDescription}</p>
                        </div>
                    </div>
                )}

                {product.advantagesDescription && (
                    <div className="accordion">
                        <button
                            className={`accordion-button ${activeSection === 'advantagesDescription' ? 'active' : ''}`}
                            onClick={() => toggleSection('advantagesDescription')}
                        >
                            Características Gerais
                        </button>
                        <div className={`accordion-content ${activeSection === 'advantagesDescription' ? 'open' : ''}`}>
                            <pre>{product.advantagesDescription}</pre>
                        </div>
                    </div>
                )}

                {/* {product.availableTypes && (
                    <div className="accordion">
                        <button
                            className={`accordion-button ${activeSection === 'availableTypes' ? 'active' : ''}`}
                            onClick={() => toggleSection('availableTypes')}
                        >
                            Modelos Disponíveis
                        </button>
                        <div className={`accordion-content ${activeSection === 'availableTypes' ? 'open' : ''}`}>
                            <pre>{product.availableTypes}</pre>
                        </div>
                    </div>
                )} */}
            </div>

            {/* Seção de Produtos Relacionados */}
            <CSSTransition
                in={inProp}
                timeout={500}
                classNames="fade"
                unmountOnExit
            >
                <div className="related-products">
                    <h2>Produtos Relacionados</h2>
                    <div className="related-products-list">
                        {relatedProducts.length > 0 ? (
                            relatedProducts.map((relatedProduct) => (
                                <div key={relatedProduct.name} className="related-product-item">
                                    <img src={relatedProduct.image} alt={relatedProduct.name} />
                                    <h3>{relatedProduct.name}</h3>
                                    <p>Visualizar Produto</p>
                                    <Link to={`/produto/${encodeURIComponent(relatedProduct.name)}`}>
                                        Ver Produto
                                    </Link>
                                </div>
                            ))
                        ) : (
                            <p>Não há produtos relacionados.</p>
                        )}
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
};

export default Info;
